<template>
    <div :class="{choose:!this.$store.state.isMobile,mchoose:this.$store.state.isMobile,mobileCommon:this.$store.state.isMobile}">
        <div class="boxes">
            <div class="box">
                <img src="../../assets/img/sign/Rectangle61.png" alt="" class="top">
                <div class="content">
                    <div class="title">{{langPage['l.general']['TXT_footdevenirmembre']}}</div>
                    <div class="tip">{{ langPage['v4-choose']['TXT_introachteur']}}</div>
                    <div class="list">
                        <div class="li">{{ langPage['v4-choose']['TXT_800paran'] }}</div>
                        <div class="li">{{ langPage['v4-choose']['TXT_200nouveauxacheteurs'] }}</div>
                        <div class="li">{{langPage['v4-choose']['TXT_vendeurtro3']}}</div>
                    </div>
                    <router-link class="blackBtn" to="/sign/signpage/buyer">{{ langPage['v4-choose']['TXT_creeruncompteacheteur'] }}</router-link>
                </div>
            </div>
            <div class="box">
                <img src="../../assets/img/sign/Rectangle62.png" alt="" class="top">
                <div class="content">
                    <div class="title">{{ langPage['v4-inscription-grossistes']['TXT_devenirvendeur'] }}</div>
                    <div class="tip">{{ langPage['v4-choose']['TXT_introvendeur'] }}</div>
                    <div class="list">
                        <div class="li">{{ langPage['v4-choose']['TXT_vendeurtro1'] }}</div>
                        <div class="li">{{ langPage['v4-choose']['TXT_vendeurtro2'] }}</div>
                        <div class="li">{{ langPage['v4-choose']['TXT_vendeurtro3'] }}</div>
                    </div>
                    <router-link class="blackBtn" to="/sign/signpage/seller">{{ langPage['v4-choose']['TXT_creeruncomptevendeur'] }}</router-link>
                </div>
            </div>
        </div>
        <BottomNav/>
    </div>
</template>

<script>

    import BottomNav from "@/components/bottomNav";
    export default {
        name: "choose",
        components: {BottomNav},
        methods: {},
        data() {
            return {}
        },
         computed: {
        langPage() {
          return this.$store.state['langPage']
        }
      },
    }

</script>

<style lang="less" scoped src="@/assets/viewCss/views/Sign/Choose.less">
</style>
